import React from 'react';
import { Dropdown } from '@insurancemenu/imenu-components-lib';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types/Dropdown';
import {
  AssignmentInd,
  ChevronDown,
  Archive,
  Unarchive,
  Delete,
  DoubleArrowRight,
  UserGroup,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRootStore } from 'store/rootStore';
import { imCelticsRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { observer } from 'mobx-react-lite';
import { BiDashboardGroupDelegate } from 'store/pages/tools/bi-groups-dashboard/biDashboardGroupDelegate';
import { DropdownButtonStyled } from './styles';

interface Props {
  groupDelegate: BiDashboardGroupDelegate;
}

const MoreDropdown: React.FC<Props> = observer(({ groupDelegate }) => {
  const {
    // TO_DO: Refactor after group overhaul
    groupsDashboardController: { openAssignAgentsModal, uploadGroupToGroupStore },
    userStore,
  } = useRootStore();

  // TO_DO: Refactor after group overhaul
  const setGroupAndOpenModal = (): void => {
    openAssignAgentsModal();
    void uploadGroupToGroupStore(groupDelegate.data.id, groupDelegate.data.agency.id);
  };

  const moveGroupDropdownOption = {
    value: 'moveGroup',
    onOptionClick: groupDelegate.moveGroup,
    icon: (): React.ReactNode => {
      // It's a specific icon, bigger than the normal ones.
      return <DoubleArrowRight width="2rem" />;
    },
    label: 'Move Group',
  };

  const viewGroupProfileOption = {
    value: 'viewGroup',
    onOptionClick: groupDelegate.setUserOrgAffiliation,
    icon: UserGroup,
    label: 'View Group Profile',
  };

  const activeGroupDropdownOptions: DropdownOptionType[] = [
    {
      value: 'assignAgents',
      onOptionClick: setGroupAndOpenModal,
      icon: AssignmentInd,
      label: 'Assign Agents',
    },
    {
      value: 'archiveGroup',
      onOptionClick: groupDelegate.archiveGroup,
      icon: Archive,
      label: 'Archive Group',
    },
    moveGroupDropdownOption,
    viewGroupProfileOption,
  ];

  const archivedGroupDropdownOption: DropdownOptionType[] = [
    {
      value: 'unarchiveGroup',
      onOptionClick: groupDelegate.unarchiveGroup,
      icon: Unarchive,
      label: 'Unarchive Group',
    },
    moveGroupDropdownOption,
    viewGroupProfileOption,
  ];

  const removeGroupOption: DropdownOptionType = {
    value: 'removeGroup',
    onOptionClick: groupDelegate.removeGroup,
    customColor: 'red',
    icon: Delete,
    label: 'Remove Group',
  };

  if (imCelticsRights(userStore.userRoles)) {
    archivedGroupDropdownOption.push(removeGroupOption);
    activeGroupDropdownOptions.push(removeGroupOption);
  }

  return (
    <Dropdown
      name="More"
      options={groupDelegate.data.archived ? archivedGroupDropdownOption : activeGroupDropdownOptions}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
      optionsWidth="20rem"
      closedElement={
        <DropdownButtonStyled $isOpened={false} color="primary" type="text" rightIconProp={<ChevronDown />}>
          MORE
        </DropdownButtonStyled>
      }
      openedElement={
        <DropdownButtonStyled color="primary" $isOpened rightIconProp={<ChevronDown />}>
          More
        </DropdownButtonStyled>
      }
    />
  );
});

export default MoreDropdown;
